var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarning = function SvgWarning(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.819 17.519l-6.285-12.57a1.714 1.714 0 0 0-3.068 0l-6.285 12.57A1.714 1.714 0 0 0 5.715 20h12.57a1.714 1.714 0 0 0 1.534-2.481zm-8.676-7.804a.857.857 0 0 1 1.714 0v3.428a.857.857 0 1 1-1.714 0V9.715zm.857 8a1.143 1.143 0 1 1 0-2.286 1.143 1.143 0 0 1 0 2.285z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "warning.b34e2bb8ddeef50a5cd39384804ceb01.svg";